import React, { Suspense, useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import useTranslation from "next-translate/useTranslation";
import CallActionsComponent from "components/v3/Listings/ListingFullDisplay/components/CallActionsComponent";
import ContactAgence from "components/v3/Listings/ListingFullDisplay/components/contactAnnonce/ContactAgence";
import $ from "utils/selectors";

function index({
  listing,
  showDesc,
  setShowDesc,
  contactAgenceHandler,
}: {
  listing: any;
  showDesc: boolean;
  setShowDesc: any;
  contactAgenceHandler: any;
}) {
  const { t, lang } = useTranslation("annonceAchat");

  const descriptionRef = useRef();
  // const [displayLanguage, setDisplayLanguage] = useState(lang);

  const [showNum, setShowNum] = useState<boolean>(false);

  const [message, setMessage] = useState<string>(
    listing
      ? t(
          `Bonjour, j'ai vu ${
            listing?.vendu
              ? "ce bien vendu"
              : listing?.transaction_type === "Vente"
              ? "le bien mis en vente"
              : listing?.transaction_type === "Location"
              ? "le bien mis en location"
              : "ce projet neuf"
          } sur agenz${
            listing.reference ? `, Ref: ${listing.reference}, ` : " "
          }${
            listing?.vendu
              ? "pourriez vous m'aider à vendre mon bien également ?"
              : `et je souhaite prendre rendez-vous pour ${
                  listing?.transaction_type === "Projets Neufs"
                    ? "mon projet immobilier"
                    : "une visite"
                }. Merci.`
          } `
        )
      : ""
  );

  return (
    <>
      {/* {listing.Description ? ( */}
      <div ref={descriptionRef} id="desc" className={`${style.descriptionNew}`}>
        {listing.Description ||
        listing.Description_ar ||
        listing.Description_en ? (
          <p
            className={
              !showDesc
                ? style.paraDescriptionContent
                : style.paraDescriptionContentMore
            }
            style={{ textAlign: lang === "ar" ? "right" : "left" }}
            dangerouslySetInnerHTML={{
              __html:
                lang == "ar"
                  ? listing.Description_ar
                    ? listing.Description_ar.replace(/\n/g, "-")
                        .replace("<p>", "")
                        .replace("</p>", "")
                    : listing.Description.replace(/\n/g, "-")
                        .replace("<p>", "")
                        .replace("</p>", "")
                  : lang == "en"
                  ? listing.Description_en
                    ? listing.Description_en.replace(/\n/g, "-")
                        .replace("<p>", "")
                        .replace("</p>", "")
                    : listing.Description?.replace(/\n/g, "-")
                        .replace("<p>", "")
                        .replace("</p>", "")
                  : listing.Description?.replace(/\n/g, "-")
                      .replace("<p>", "")
                      .replace("</p>", ""),
            }}
          ></p>
        ) : null}
        <div className={style.callCon}>
          {showDesc ? (
            <div className={style.contactDesc}>
              <CallActionsComponent
                descriptionStyle={true}
                listing={listing}
                message={message}
                contactAgenceHandler={contactAgenceHandler}
                agence={listing.agence}
                t={t}
                lang={lang}
                showNum={showNum}
                setShowNum={setShowNum}
                style={{ height: "44px", gap: "4px" }}
              />
            </div>
          ) : null}
          {/* {(listing.Description || listing.Description_ar) ? ( */}
          <span
            className={style.voirBtn}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setShowDesc(!showDesc);
            }}
          >
            <span
              className={`${
                !showDesc ? style.iconVoirPlus : style.iconVoirMoin
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="16"
                viewBox="0 0 15 16"
                fill="none"
              >
                <path
                  d="M3.125 9.875L7.5 5.5L11.875 9.875"
                  stroke="#00111A"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            {!showDesc ? t("Voir plus") : t("Voir moins")}
          </span>
          {/* ) : (null)} */}
        </div>
      </div>
      {/* ) : null} */}
    </>
  );
}

export default index;
